export default "__VITE_ASSET__BPUcwjnX__"